import { Alert } from '@c1/gravity-react';
import { FunctionComponentProps, FunctionComponentReturnType } from "src/types/sharedReact";
import 'src/components/AlertBanner/AlertBanner.css';
import clsx from 'clsx';
import { isMobile } from 'react-device-detect';
import React, { useEffect, useState } from 'react';
import { GetBannerResponse } from 'src/types/apiResponse';
import { AxiosError } from 'axios';
import RouteBuilder from 'src/utils/routing/RouteBuilder';
import { useRouteBuilder } from 'src/utils/routing/RouteBuilderContext';
import { getFromApi } from 'src/utils/getFromApi';
import 'src/components/MaintenanceBanner/MaintenanceBanner.css'
import { Banner } from 'src/types/banner';
import { BannerType } from 'src/types/bannerType';

function MaintenanceBanner({bannerUtilityRef}): FunctionComponentReturnType {
    const [banners, setBanners] = useState<Banner[] | null>(null);
    const [bannerTypes, setBannerTypes] = useState<BannerType[] | null>(null);
    const [error, setError] = useState<AxiosError | null>(null);
    const [type, setType] = useState<string | null>(null);
    const routeBuilder: RouteBuilder = useRouteBuilder();
    const apiRoute: string = routeBuilder.api.getCurrentBanner();

    const HOURS_UNTIL_EXPIRY = 24;
    const BANNER_SEEN_PREFIX = "has_seen_";

    useEffect(getFromApi(apiRoute, handleData, setError), [apiRoute]);

    function handleData(data: GetBannerResponse) {
        if (data.banners.length > 0) {
            setBannerTypes(data.bannerTypes);
            let bannersSeen = checkBannerVisibilityAndUpdate(data.banners);
            let bannerList: Banner[] = []
            data.banners?.forEach((banner) => {
                if(banner) {
                    banner.isActive = banner?.isActive && bannersSeen?.indexOf(banner?.bannerId) === -1;
                    banner.bannerType = data.bannerTypes.filter((type) => {
                        return type.bannerCode == banner.bannerType
                    })[0].alertCode
                    banner.actionText = "Acknowledge"
                    banner.callback = ((self) => {
                        console.log("Closing bannerId: ", self.bannerId);
                        localStorage.setItem(BANNER_SEEN_PREFIX + self.bannerId, Date.now().toString());
                    })



                    bannerUtilityRef?.current?.addBanner(banner)
                }

            });
        }
    }
    function checkBannerVisibilityAndUpdate(banners: Banner[]) {
        let output = [];
        let bannersSeen = Object.keys(localStorage).filter((key) => key.includes(BANNER_SEEN_PREFIX));
        for (let i = 0; i < bannersSeen.length; i++) {
                let bannerId = bannersSeen[i].substr(bannersSeen[i].indexOf(BANNER_SEEN_PREFIX) + BANNER_SEEN_PREFIX.length, 36);
            if((Date.now() - localStorage[bannersSeen[i]] > HOURS_UNTIL_EXPIRY * 60 * 60 * 1000) || banners.filter((banner) => banner?.bannerId === bannerId)[0] === undefined) {
                localStorage.removeItem(bannersSeen[i]);
            } else {
                output.push(bannerId)
            }
        }
        return output;
    }
    return null;
}

export default MaintenanceBanner;
